/**
 * Catalogue services — aligné sur la logique `fronthagd` (médias Django, icônes FA).
 */

export const PLACEHOLDER_FA = "fas fa-concierge-bell";

/** URL absolue pour un ImageField (chemin relatif ou URL complète). */
export function resolveMediaUrl(
  path: string | null | undefined,
  apiBaseUrl: string,
): string | null {
  if (path == null || path === "") return null;
  const s = String(path).trim();
  if (!s || s.includes("default.png")) return null;
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  const base = apiBaseUrl.replace(/\/$/, "");
  return `${base}${s.startsWith("/") ? s : `/${s}`}`;
}

/** Hex #RRGGBB + suffixe alpha 8 bits (#RRGGBBAA). */
export function hexWithAlpha(hex: string, alphaSuffix: string): string {
  const h = hex.trim();
  if (/^#[0-9A-Fa-f]{6}$/i.test(h)) return `${h}${alphaSuffix}`;
  return "rgba(148, 163, 184, 0.2)";
}

export function faIconClass(
  icon: string | null | undefined,
  placeholder = PLACEHOLDER_FA,
): string {
  const ic = icon != null ? String(icon).trim() : "";
  if (ic && ic !== "icon") return ic;
  return placeholder;
}

export function faIconColor(
  colorField: string | null | undefined,
  fallback: string,
): string {
  const t = colorField != null ? String(colorField).trim() : "";
  if (t && t !== "color" && /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(t)) return t;
  return fallback;
}

export function servicePriceLabel(
  svc: { has_defined_price?: boolean; price?: string | number | null },
  priceFreeLabel: string,
  priceZeroLabel = "GRATUIT",
): string {
  if (!svc.has_defined_price || svc.price == null || svc.price === "") return priceFreeLabel;
  const n = Number(svc.price);
  if (Number.isFinite(n) && n === 0) return priceZeroLabel;
  if (Number.isFinite(n)) return `${n.toFixed(2)} €`;
  return `${svc.price} €`;
}

export function serviceDurationLabel(
  svc: { duration?: number },
  unknownLabel: string,
): string {
  const d = Number(svc?.duration);
  if (!Number.isFinite(d) || d <= 0) return unknownLabel;
  return `${d} min`;
}

export function serviceMaxUsersCount(svc: { maxUsers?: number }): number {
  const m = Number(svc?.maxUsers);
  return Number.isFinite(m) && m >= 1 ? m : 1;
}
